import { useData, useFilter, usePatchFilter } from './context';
import {
  ActivityHeaderCol,
  ActivityDuration,
  ActivityHeader,
  ActivityTitle,
  ContentBoard,
  SummaryStats,
  StatCard,
} from '../styledComponents';
import React from 'react';

const formatMs = (ms) => {
  if (!ms) return '–';
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${ms}ms`;
};

export default function Header() {
  const { summary } = useData();
  const filter = useFilter();
  const patchFilter = usePatchFilter();

  return (
    <ContentBoard>
      <ActivityHeader>
        <ActivityHeaderCol>
          <ActivityTitle>Partner API Statistics</ActivityTitle>
          <ActivityDuration>
            <div
              className={filter.period === 'day' ? 'active' : ''}
              onClick={() => patchFilter({ period: 'day' })}
            >
              Today
            </div>
            <div
              className={filter.period === 'week' ? 'active middle' : 'middle'}
              onClick={() => patchFilter({ period: 'week' })}
            >
              7 days
            </div>
            <div
              className={filter.period === 'month' ? 'active' : ''}
              onClick={() => patchFilter({ period: 'month' })}
            >
              30 days
            </div>
          </ActivityDuration>
        </ActivityHeaderCol>

        {summary && (
          <SummaryStats>
            <StatCard>
              <span className='label'>Total requests</span>
              <span className='value'>{summary.total ?? '–'}</span>
            </StatCard>
            <StatCard>
              <span className='label'>Verified</span>
              <span className='value'>{summary.verified ?? '–'}</span>
            </StatCard>
            <StatCard>
              <span className='label'>Not found</span>
              <span className='value'>{summary.notFound ?? '–'}</span>
            </StatCard>
            <StatCard>
              <span className='label'>Avg response</span>
              <span className='value'>{formatMs(summary.avgResponseTimeMs)}</span>
            </StatCard>
          </SummaryStats>
        )}
      </ActivityHeader>
    </ContentBoard>
  );
}
